import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@assets/images/star.png'


const _hoisted_1 = { class: "capability-container" }
const _hoisted_2 = { class: "capability-right" }
const _hoisted_3 = { class: "capability-right-bottom" }
const _hoisted_4 = ["innerHTML"]

import { ref, reactive, onMounted, watch, computed, getCurrentInstance,onUnmounted } from 'vue'
import * as echarts from 'echarts';
import getCapabilityOption from '@/hooks/useCapabilityOption'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {

},
  emits: ["onClick", "onClose"],
  setup(__props, { emit: __emit }) {

const { proxy } = getCurrentInstance()!
// Props
const props = __props
// Emits定义
const emit = __emit
const activeText = ref('时间、油门、副翼、升降舵')
// 组件状态
const trainDuideTextTemp = ref(`
    <p>你在<span style="color: #2174FF">${activeText.value}</span>方面有较好的掌控能力；你在方向舵方面的掌控能力偏薄弱，你可以在360°自旋、8字飞行中强化练习。</p>
`)
const states = reactive({
    echart: null as any,
})
const options = reactive(getCapabilityOption())

// 监听器和计算属性

// 组件方法
const initEcharts = () => {
    const echartBox = document.getElementById('echartBox') as HTMLElement
    states.echart = echarts.init(echartBox)
    states.echart.setOption(options)
}

const resizeEcharts = () => {
    states.echart.resize()
}


// 生命周期
onMounted(() => {
    initEcharts()
    window.addEventListener('resize', resizeEcharts)
})
onUnmounted(() => {
    window.removeEventListener('resize', resizeEcharts)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "capability-left" }, [
      _createElementVNode("div", {
        class: "echart-container",
        id: "echartBox"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "capability-right-top" }, [
        _createElementVNode("div", { class: "icon-container" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          }),
          _createElementVNode("span", null, "综合得分")
        ]),
        _createElementVNode("span", { class: "score" }, "8.2")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "train-guide-title" }, "训练指导", -1)),
        _createElementVNode("div", {
          class: "train-guide-content",
          innerHTML: trainDuideTextTemp.value
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}
}

})